import React, { useState, useEffect, useRef }  from 'react';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import QueuedPostRequest from 'components/layout_and_quote_builder/utils/QueuedPostRequest.js';
// import LayoutNavSectionCombinationImg from 'components/layout_and_quote_builder/LayoutNavSectionCombinationImg.jsx'
import LayoutSvg from 'components/layout_and_quote_builder/quote_builder/LayoutSvg.jsx'

const LayoutNavSectionCombination = ( { diecutting_result, count, layout_dimension, setTotalScoreList, index , setNumTotals, setNumOfDrawingsInSet} ) => {
  const name = `${diecutting_result.uuid}`;

  // Helper function to format dimensions - removes .0 for whole numbers
  const formatDimension = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    // If it's a whole number, show without decimals
    return num % 1 === 0 ? num.toFixed(0) : num.toString();
  };

  const [cuttingScore, setCuttingScore] = useState( 0 )
  const [printingScore, setPrintingScore] = useState( 0 )
  const [materialScore, setMaterialScore] = useState( 0 )
  const [kesim_num_total, set_kesim_num_total] = useState( 0 )
  const [print_num_total, set_print_num_total] = useState( 0 )

  const [score, setScore] = useState( 0 )
  const [printingImageUrl, setPrintingImageUrl] = useState( '')
  const [diecuttingImageUrl, setDiecuttingImageUrl] = useState( '')
  const [numTotal, setNumTotal] = useState(0);
  const [numOfDrawingInSet, setNumOfDrawingInSet] = useState(1);
  const [efficiency, setEfficiency] = useState(null);

  const [partTypes, setPartTypes] = useState([])
  const requestInFlightRef = useRef(false);
  const [calculated_output_dimensions, set_calculated_output_dimensions] = useState("")

  const [cuttingMachineLayoutDimensionsInMmWidth, setCuttingMachineLayoutDimensionsInMmWidth] = useState(0)
  const [cuttingMachineLayoutDimensionsInMmHeight, setCuttingMachineLayoutDimensionsInMmHeight] = useState(0)
  const [printingMachineLayoutDimensionInMmWidth, setPrintingMachineLayoutDimensionInMmWidth] = useState(0)
  const [printingMachineLayoutDimensionInMmHeight, setPrintingMachineLayoutDimensionInMmHeight] = useState(0)

  const getScore = () => {
    if(score > 0) { return }
    if(requestInFlightRef.current) { return }

    requestInFlightRef.current = true;

    QueuedPostRequest({
      url: `/layouts-nav-section-combination-score`,
      data: {
        formula_options: window.dielineOptions,
        diecutting_result: diecutting_result,
        count: count,
        id: window.drawingId,
        layout_dimension_id: layout_dimension.id
      },
      callback: (data) => {
        setScore( () => data.score )
        setNumTotal( () => data.diecutting_num_total )
        setNumOfDrawingInSet( () => data.num_of_drawings_in_set )
        setPrintingImageUrl( () => data.printing_result_image_url )
        setDiecuttingImageUrl( () => data.diecutting_result_image_url  )
        setEfficiency( () => data.efficiency )

        setCuttingScore( () => data._score_debug.cutting )
        setPrintingScore( () => data._score_debug.printing )
        setMaterialScore( () => data._score_debug.material )
        set_kesim_num_total( () => data._score_debug.kesim_num_total )
        set_print_num_total( () => data._score_debug.print_num_total )

        setCuttingMachineLayoutDimensionsInMmWidth( () => data.cutting_machine_layout_dimensions_in_mm?.width  )
        setCuttingMachineLayoutDimensionsInMmHeight( () => data.cutting_machine_layout_dimensions_in_mm?.height )

        setPrintingMachineLayoutDimensionInMmWidth( () => data.printing_machine_layout_dimension_in_mm?.width )
        setPrintingMachineLayoutDimensionInMmHeight( () => data.printing_machine_layout_dimension_in_mm?.height )

        set_calculated_output_dimensions( () => data.calculated_output_dimensions.output_x_length + " x " + data.calculated_output_dimensions.output_y_length )

        setNumTotals((prev) => {
          return {
            ...prev,
            [index]: data.diecutting_num_total,
          };
        });

        setNumOfDrawingsInSet((prev) => {
          return {
            ...prev,
            [index]: data.num_of_drawings_in_set,
          };
        });

        requestInFlightRef.current = false;
      }
    }).catch((error) => {
      console.error('[LayoutNavSectionCombination getScore] Unhandled error:', error);
      requestInFlightRef.current = false;
    })
  }

  useEffect(() => {
    setTotalScoreList(prev => ({
      ...prev,
      [index]: score,
    }));
  }, [score]);

  const description_for = (layout_dimension) => {
    const { unit, locale } = window.user_quote;
    return layout_dimension[`description_${locale}_${unit}`];
  };

  const machineIcon = () => {
    return <sup><strong> <i className="fa fa-cogs" aria-hidden="true"></i> </strong></sup>
  }

  const showMachineDimensionsForPrint = () => {
    return printingMachineLayoutDimensionInMmHeight != 0 && printingMachineLayoutDimensionInMmHeight != '' && printingMachineLayoutDimensionInMmHeight != undefined;
  }

  const showMachineDimensionsForCutting = () => {
    return cuttingMachineLayoutDimensionsInMmHeight != 0 && cuttingMachineLayoutDimensionsInMmHeight != '' && cuttingMachineLayoutDimensionsInMmHeight != undefined;
  }

  const printingCard = () => {
     return <table>
        <tbody>

          <tr>
            <th> {t('layouts.layout_type_printing')} </th>
          </tr>

          <tr>
            <td> <img className="additional_feature_img tag_img_white_bg" src={printingImageUrl} width="250" /> </td>
          </tr>

          {!showMachineDimensionsForPrint() && (
          <tr className={styles.card_info_machine}>
            <td> <span> {t('quote_builder.machine_and_material_dimensions')} </span> </td>
          </tr>)}

          {showMachineDimensionsForPrint() && (
          <tr className={styles.card_info_machine}>
           <td> <span > {t('quote_builder.material_dimensions')} </span> </td>
          </tr>)}

          <tr>
            <td> <span className={styles.card_info}> {description_for(diecutting_result.printing_result.layout_dimension)} </span> </td>
          </tr>

          {window.user_unit == 'mm' && showMachineDimensionsForPrint() && (
          <>
          <tr className={styles.card_info_machine}>
            <td> <span > {t('quote_builder.machine_dimensions')} </span> </td>
          </tr>

          <tr>
            <td>
              <span className={styles.card_info}>
                {formatDimension(printingMachineLayoutDimensionInMmHeight)}mm X {formatDimension(printingMachineLayoutDimensionInMmWidth)}mm
              </span>
            </td>
          </tr>
          </>)}

          {window.user_unit == 'in' && showMachineDimensionsForPrint() && (
          <>
          <tr className={styles.card_info_machine}>
            <td> <span > {t('quote_builder.machine_dimensions')} </span> </td>
          </tr>
          <tr>
            <td>
              <span className={styles.card_info}>
                {formatDimension((printingMachineLayoutDimensionInMmHeight / 25.4).toFixed(2))}in X {formatDimension((printingMachineLayoutDimensionInMmWidth / 25.4).toFixed(2))}in
                </span>
              </td>
          </tr>
          </>)}

        </tbody>
      </table>
  }

  const diecuttingCard = () => {
     return <table>
        <tbody>
          <tr>
             <th> {t('layouts.layout_type_die_cutting')} </th>
          </tr>

          <tr>
            <td> <img className="additional_feature_img tag_img_white_bg" src={diecuttingImageUrl} width="250" /> </td>
          </tr>

          {!showMachineDimensionsForCutting() && (
          <tr className={styles.card_info_machine}>
            <td> <span> {t('quote_builder.machine_and_material_dimensions')} </span> </td>
          </tr>)}

          {showMachineDimensionsForCutting() && (
          <tr className={styles.card_info_machine}>
            <td> <span > {t('quote_builder.material_dimensions')} </span> </td>
          </tr>)}


          <tr>
            <td> <span className={styles.card_info}> {description_for(diecutting_result.layout_dimension)} </span> </td>
          </tr>

         {window.user_unit == 'mm' && showMachineDimensionsForCutting() && (

          <>
           <tr className={styles.card_info_machine}>
            <td> <span > {t('quote_builder.machine_dimensions')} </span> </td>
            </tr>
          <tr>
            <td> <span className={styles.card_info}> {formatDimension(cuttingMachineLayoutDimensionsInMmHeight)}mm X {formatDimension(cuttingMachineLayoutDimensionsInMmWidth)}mm </span> </td>
          </tr>
          </>)}

         {window.user_unit == 'in' && showMachineDimensionsForCutting() && (
          <>
           <tr className={styles.card_info_machine}>
              <td> <span > {t('quote_builder.machine_dimensions')} </span> </td>
           </tr>
          <tr>
            <td> <span className={styles.card_info}> {formatDimension((cuttingMachineLayoutDimensionsInMmHeight / 25.4).toFixed(2))}in X {formatDimension((cuttingMachineLayoutDimensionsInMmWidth / 25.4).toFixed(2))}in </span> </td>
          </tr>
          </>)}

        </tbody>
      </table>
  }


  const card = () => {

    return <table className="table table-striped table-bordered">
      <tbody>

       {partTypes.length > 0 && (
        <tr>
          <th colSpan="2">
            <span className={styles.card_th}> {partTypes.join(", ")}, {diecutting_result.member.part_names.join(", ")} </span>
          </th>
        </tr>
        )}

       {window.isAdminShowDebug && (
        <>
        <tr>
          <td colSpan="2"> {score} </td>
        </tr>

        <tr>
          <td className={styles.card_td}> { diecuttingCard() } </td>
          <td className={styles.card_td}> { printingCard() } </td>
        </tr>

        <tr>
          <td> toplam {kesim_num_total} </td> <td>  toplam {print_num_total} </td>
        </tr>

        <tr>
          <td> Kesim score: {cuttingScore} </td> <td> Baski score: {printingScore} </td>
        </tr>

        <tr>
           <td>
           ({calculated_output_dimensions})
           </td> <td> Malzeme score: {materialScore} </td>
        </tr>
        </>
        )}

      </tbody>
    </table>
  }

  // useEffect starts
  useEffect( getScore, [ diecutting_result, count] )
  useEffect( () =>  {
    for(let i=0; i < diecutting_result.member.part_types.length; i++) {
      let partType = diecutting_result.member.part_types[i];

      setPartTypes((prev) => {
        const newItem = t("quote_builder.part_type_" + partType);
        return Array.from(new Set([...prev, newItem]));
      });

    }
  }, [ diecutting_result, count] )

  // useEffect ends

  if(score == 0) { return <div key={name} data-score={score}> loading....</div> }

  return (
    <div className={styles.combinations_grid_item}
      key={name}
      data-score={score}
      data-num-total={numTotal}
      data-num-of-drawing-in-set={numOfDrawingInSet}
      style={{position: 'relative'}} >

      {efficiency !== null && (
        <div className={styles.efficiency_badge}>
          {efficiency.toFixed(2)}%
        </div>
      )}

      {card()}

    </div>
  )
}

export default LayoutNavSectionCombination;
